/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ShowcaseComponent} from './showcase/showcase.component';
import {ModalComponent} from './modal/modal.component';
import {DatePickerComponent} from './date-picker/date-picker.component';
import {TypeaheadConfig} from "./type-ahead-input/typeahead-config.component";
import {FormsModule} from '@angular/forms';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgbModule,
  ],
  declarations: [
    ShowcaseComponent,
    ModalComponent,
    DatePickerComponent,
    TypeaheadConfig,

  ],
  exports: [
    ShowcaseComponent,
    ModalComponent,
    DatePickerComponent,
    TypeaheadConfig,

  ]
})
export class DesignLibraryModule {
}
